// unit: millisecond
export const DELAY_NEWSLETTER_MODAL = 45000;

// unit: second
export const ONE_MINUTE = 60;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const ONE_MONTH = ONE_DAY * 30;
export const SIX_MONTH = ONE_MONTH * 6;
